import React from 'react';

import { BrandPendulumMark } from '../components/BrandPendulumMark';
import './NetworkErrorPage.css';

const NetworkErrorPage: React.FC = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <main className="network-error-container">
      <header className="network-error-header">
        <a className="network-error-brand" href="/" aria-label="8080 AI home">
          <BrandPendulumMark className="network-error-brand__mark" />
          <span className="network-error-brand__label">8080.AI</span>
        </a>
      </header>

      <section className="network-error-card" aria-labelledby="network-error-title">
        <BrandPendulumMark className="network-error-pendulum" />

        <div className="network-error-status">
          <span className="network-error-status__dot" aria-hidden="true" />
          Connection interrupted
        </div>

        <h1 id="network-error-title" className="network-error-title">Cannot Connect to Servers</h1>

        <p className="network-error-message">
          8080.AI can&apos;t reach its services right now. Check your connection, then try again.
        </p>

        <button
          className="network-error-btn app-action-btn app-action-btn--primary"
          onClick={handleRetry}
          type="button"
        >
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 11a8.1 8.1 0 0 0-15.5-2M4 4v5h5" />
            <path d="M4 13a8.1 8.1 0 0 0 15.5 2M20 20v-5h-5" />
          </svg>
          Retry Connection
        </button>
      </section>
    </main>
  );
};

export default NetworkErrorPage;
